<ui-table
  *ngIf="pager$ | async as pager"
  [fields]="fields"
  [pager]="pager"
  [itemsPage]="(page$ | async)?.current"
  [itemsPerPage]="(page$ | async)?.limit"
  (itemsPageChange)="applyChangePageHandler($event)"
  [reload]="reload$"
  [contextMenuActions]="contextMenus"
  (select)="selectHandler($event)">
  <div
    class="bind-card-container"
    tableActions>
    <mat-select
      #cardType
      [value]="'oa'">
      <mat-option
        [value]="option.value"
        *ngFor="let option of cardOptions">
        {{ option.label }}
      </mat-option>
    </mat-select>
    <button
      mat-raised-button
      (click)="bindCardHandler(cardType.value)">
      Collega bene
    </button>
  </div>
</ui-table>
